import { BaseModel } from '../../_base/crud';

export class OrderEvent extends BaseModel {
	id: number;
	campaignNumber: string;
	creationDate: string;
	userName: string;
	firstName: string;
	lastName: string;
	orderEventOriginType: string;
	orderEventTypeId: number;
	orderEventStatus: string;
	orderId: number;
	orderEventItems: any[];
	applicationUserId: any;
	orderEventTrackings: any[];
    replacementItems: any[];
    orderEventProducts: any;
    orderEventResultId: any;
    generateCreditNote: boolean;
    zone: string;
	amount: number;
}

export const originsMap = {
	'ZoneManager': 'Gerente Zonal',
	'Administrative': 'Administrativo',
	'Automatic': 'Automático',
};

export const statusMap = {
	'New': 'Nuevo',
	// 'Processing': 'Procesando',
	// 'Delegate': 'Delegado',
    'ApprovedProductChange': 'Cambio de producto aprobado',
    'ZonalManagerReceivedOldProducts': 'Gerente zonal recibió los productos',
    'GigotReceivedOldProducts': 'Gigot recibió los productos',
    'GigotSendsInOrdersProducts': 'Gigot envió los productos',
    'Resolved': 'Resuelto',
};
